import { put, call, all, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import get from 'lodash/get';
import {
  fetchShipmentTypeDetailsSuccess,
  fetchShipmentTypeDetailsFailure,
  fetchShipmentsSuccess,
  fetchShipmentsFailure,
} from './actions';

import axiosConfig from './axiosConfig';
import { FETCH_SHIPMENT_TYPE_DETAILS, FETCH_SHIPMENTS } from './types';

function* fetchShipmentTypeDetails(payload) {
  try {
    let url;

    if (payload.pageNumber && payload.pageSize && payload.searchKey) {
      url = `/shipment-type?searchKey=${payload.searchKey}&expiryDate=${payload.expiryDate}&pageSize=${payload.pageSize}&pageNumber=${payload.pageNumber}`;
    } else if (payload.pageNumber && payload.pageSize) {
      url = `/shipment-type?pageSize=${payload.pageSize}&pageNumber=${payload.pageNumber}`;
    } else if (payload.searchKey) {
      url = `/shipment-type?searchKey=${payload.searchKey}`;
    } else {
      url = '/shipment-type';
    }

    const res = yield axiosConfig.get(url);
    const response = get(res, ['data', 'data'], {});
    // notification.destroy();
    if (res.status === 200) {
      yield put(fetchShipmentTypeDetailsSuccess({ response }));
    } else {
      notification.error({
        message: 'Something went wrong.',
      });
    }
  } catch (error) {
    yield put(fetchShipmentTypeDetailsFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occured while fetching the Shipment details.',
      description: `${error}`,
    });
  }
}

function* fetchShipments(payload) {
  try {
    const params = new URLSearchParams();
    if (payload?.status) params.set('status', payload.status);
    if (payload?.projectId != null && payload.projectId !== '') params.set('projectId', payload.projectId);
    if (payload?.pageSize != null) params.set('pageSize', payload.pageSize);
    if (payload?.pageNumber != null) params.set('pageNumber', payload.pageNumber);
    if (payload?.searchKey != null && payload.searchKey !== '') params.set('searchKey', payload.searchKey);
    const query = params.toString();
    const url = query ? `/shipments?${query}` : '/shipments';
    const res = yield axiosConfig.get(url);
    const response = get(res, ['data', 'data'], {});
    if (res.status === 200) {
      yield put(fetchShipmentsSuccess({ response }));
    } else {
      notification.error({
        message: 'Something went wrong.',
      });
    }
  } catch (error) {
    yield put(fetchShipmentsFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occurred while fetching the Shipment details.',
      description: `${error}`,
    });
  }
}

function* shipmentWatcher() {
  yield takeLatest(FETCH_SHIPMENT_TYPE_DETAILS, fetchShipmentTypeDetails);
  yield takeLatest(FETCH_SHIPMENTS, fetchShipments);
}

function* shipmentSagas() {
  yield all([call(shipmentWatcher)]);
}

export default shipmentSagas;

export const OnAddorUpdateShipmentType = async (payload, isEdit) => {
  try {
    let res = '';
    if (isEdit) {
      res = await axiosConfig.put(`/shipment-type/${encodeURIComponent(payload.id)}`, payload.data);
    } else res = await axiosConfig.post(`/shipment-type`, payload.data);
    const response = get(res, ['data', 'data'], {});
    notification.destroy();
    if (res.status === 200) {
      notification.success({
        message: isEdit
          ? 'Shipment type updated successfully.'
          : 'Shipment type added successfully.',
      });
      return response;
    } else {
      notification.error({
        message: 'Something went wrong.',
      });
    }
    return false;
  } catch (error) {
    notification.destroy();
    notification.error({
      message: 'A problem occured while adding the details.',
      description: `${error.error}`,
    });
    return false;
  }
};

export const OnDeleteShipmentType = async (payload) => {
  try {
    const res = await axiosConfig.delete(`/shipment-type/${payload.id}`);
    const response = get(res, ['data', 'data'], {});
    notification.destroy();
    if (res.status === 200) {
      notification.success({
        message: 'Shipment type deleted successfully.',
      });
      return response;
    } else {
      notification.error({
        message: 'Something went wrong.',
      });
    }
    return false;
  } catch (error) {
    notification.destroy();
    notification.error({
      message: 'A problem occured while adding the details.',
      description: `${error.error}`,
    });
    return false;
  }
};

export const OnAddorUpdateShipmentNumber = async (payload, isEdit) => {
  try {
    let res = '';
    if (isEdit) {
      res = await axiosConfig.put(`shipments/${encodeURIComponent(payload.id)}`, payload.data);
    } else res = await axiosConfig.post(`/shipments`, payload);
    const response = get(res, ['data', 'data'], {});
    notification.destroy();
    if (res.status === 200) {
      notification.success({
        message: isEdit
          ? 'Shipment number updated successfully.'
          : 'Shipment number added successfully.',
      });
      return response;
    } else {
      notification.error({
        message: 'Something went wrong.',
      });
    }
    return false;
  } catch (error) {
    notification.destroy();
    notification.error({
      message: 'A problem occured while adding the details.',
      description: `${error.error}`,
    });
    return false;
  }
};

export const OnAddShipmentNumber = async (payload) => {
  try {
    const res = await axiosConfig.post('/shipments/v2', payload);
    const response = get(res, ['data', 'data'], {});
    notification.destroy();

    if (res.status === 200) {
      notification.success({
        message: 'Shipment number added successfully.',
      });
      return response;
    } else {
      notification.error({
        message: 'Something went wrong.',
      });
      return false;
    }
  } catch (error) {
    notification.destroy();
    notification.error({
      message: 'A problem occurred while adding the shipment.',
      description: `${error?.message || 'Unknown error'}`,
    });
    return false;
  }
};

export const OnPreviewShipmentNumber = async (shipmentTypeId) => {
  try {
    const res = await axiosConfig.get(`/shipments/preview?shipmentTypeId=${shipmentTypeId}`);
    const response = get(res, ['data', 'data'], {});

    if (res.status === 200) {
      return response;
    } else {
      notification.error({
        message: 'Something went wrong while previewing shipment number.',
      });
      return false;
    }
  } catch (error) {
    notification.destroy();
    notification.error({
      message: 'A problem occurred while previewing the shipment number.',
      description: `${error?.message || 'Unknown error'}`,
    });
    return false;
  }
};

export const OnDeleteShipmentNumber = async (payload) => {
  try {
    const res = await axiosConfig.delete(`/shipments/${payload.id}`);
    const response = get(res, ['data', 'data'], {});
    notification.destroy();
    if (res.status === 200) {
      notification.success({
        message: 'Shipment number deleted successfully.',
      });
      return response;
    } else {
      notification.error({
        message: 'Something went wrong.',
      });
    }
    return false;
  } catch (error) {
    notification.destroy();
    notification.error({
      message: 'A problem occured while adding the details.',
      description: `${error.error}`,
    });
    return false;
  }
};

/** Get all listed equipment types*/
export const OnFetchShipmentSno = async (payload, admin = 'true') => {
  try {
    var res;

    res = await axiosConfig.get(`/shipment-type/${payload.id}?admin=${admin}`);

    const response = get(res, ['data', 'data'], {});
    if (res.status === 200) {
      return response;
    } else {
      notification.warn({
        message: 'Something went wrong. Please Reload and try again',
      });
      return null;
    }
  } catch (error) {
    notification.destroy();
    notification.error({
      message: 'A problem occured while fetching the Equipments.',
      description: `${error.error}`,
    });
    return null;
  }
};

export const getExportDataListFromDatabase = async (payload) => {
  try {
    let url;

    if (payload && JSON.stringify(payload.searchKey)) {
      const encodedSearchKey = encodeURIComponent(JSON.stringify(payload.searchKey));
      url = `/shipment-type?searchKey=${encodedSearchKey}`;
    } else {
      url = `/shipment-type`;
    }

    const res = await axiosConfig.get(url);
    if (res.status === 403) {
      notification.error({
        message: 'Unauthorized',
      });
      return null;
    }
    if (res.status === 200) {
      const data = get(res, ['data', 'data'], {});
      return data;
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const OnBulkUpdateShipmentStatus = async (payload) => {
  try {
    const res = await axiosConfig.put('/shipments/bulk/status', payload);
    const response = get(res, ['data', 'data'], {});
    notification.destroy();

    if (res.status === 200) {
      notification.success({
        message: 'Shipment statuses updated successfully.',
      });
      return response;
    } else {
      notification.error({
        message: 'Something went wrong.',
      });
      return false;
    }
  } catch (error) {
    notification.destroy();
    notification.error({
      message: 'A problem occurred while updating shipment statuses.',
      description: `${error?.message || 'Unknown error'}`,
    });
    return false;
  }
};
